
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { areaSaggioClasseDiametricaStore } from '../store/areaSaggioClasseDiametrica.store';
import numeric from '@/components/inputs/numeric';
import { layoutHelper } from '@/helpers/LayoutHelper';
import { Guid } from 'guid-typescript';

Vue.component("classe-diametrica-cell", () => !layoutHelper.isWeb ? import("./mobile/classeDiametricaCell.vue") : import("./web/classeDiametricaCell.vue"));

@Component({})
export default class ClasseDiametricaRow extends Vue {

  @Prop({ required: true })
  versioneId: string;

  @Prop({ required: true })
  areaSaggio: string;

  @Prop({ required: true })
  classeDiametrica: number;

  @Prop({ required: true })
  specieArboree: number[];

  @Prop({ required: true })
  rilevamenti: server.areaSaggioClasseDiametrica[];

  @Prop()
  selected: server.areaSaggioClasseDiametrica;

  get rowCells(): server.areaSaggioClasseDiametrica[] {
    if (this.rilevamenti.length <= 0 || this.specieArboree.length <= 0) return [];

    return this.specieArboree.map((specieArborea) => {
      let elem = this.rilevamenti.find(f => f.diametro == this.classeDiametrica && f.specie === specieArborea);
      if (elem) return elem;
      elem = {
        id: Guid.create().toString(),
        versioneId: this.versioneId,
        areaSaggioId: this.areaSaggio,
        specie: specieArborea,
        diametro: this.classeDiametrica,
        contatore: 0
      } as server.areaSaggioClasseDiametrica
      areaSaggioClasseDiametricaStore.actions.setAreaSaggioClasseDiametrica(elem);
    })
  }


  public select(cell) {
    this.$emit('select', cell);
  }
}